import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError, concatMap, from, of } from 'rxjs';
import { COTIZACION_PAUSA, LOADER_MOTO, ONEROSO } from '../../../../routes.constans';
import { LeadsService } from '../../../../services/Leads/leads.service';
import { ButtonComponent } from '../../../components/button/button.component';

import { getFromStorage, getSessionId, saveToStorage } from '../../../../helpers/storageUtils';
import { UploadFileService } from '../../../services/onerous/uploadfile.service';

import { CurrencyFormatterDirective } from '../../../../directives/currency-formatter.directive';
import { DataLayerService } from '../../../../services/DataLayer/data-layer.service';
import { ExceptionService } from '../../../../services/excepciones/exception.service';
import { UtmHandlerService } from '../../../services/utm-handler.service';
import { Accessory, SelectedAccessory } from '../../interfaces/accessories/accessories.interface';
import { reqUploadFile, UploadedFile } from '../../interfaces/new-vehicle/new-vehicle.interface';
import { CEROKM } from '../../onerous-pages.constants';
import { FileUploadComponent } from '../file-upload/file-upload.component';

@Component({
  selector: 'app-accessories',
  templateUrl: './accessories.component.html',
  styleUrl: './accessories.component.scss',
  standalone: true,
  imports: [
    //MODULOS
    CommonModule,
    FormsModule,

    //COMPONENTES
    ButtonComponent,
    FileUploadComponent,
    CurrencyFormatterDirective,
  ],
})
export class AccessoriesComponent implements OnInit {
  utmHandlerService = inject(UtmHandlerService);
  private dataLayerService = inject(DataLayerService);
  disabled = signal(true);
  // Valor total en pesos (como signal para reactividad)
  totalValue = signal<string>('');
  // Mensaje de error
  showError = signal<boolean>(false);
  showAccesoryError = signal<boolean>(false);
  errorMessage = signal<string>('');

  router = inject(Router);
  leadData: unknown;
  OnerousValue = '';
  leadService = inject(LeadsService);
  disableUpdatedFile = signal<boolean>(true);
  filesToSend = signal<UploadedFile[]>([]);
  uploadFileService = inject(UploadFileService);

  ceroKmPlusAccesoriesValue = signal<string | number | null>(0);

  // Lista completa de accesorios disponibles
  allAccessories = signal<Accessory[]>([
    { id: '1', name: 'Alarma' },
    { id: '2', name: 'Barras Protección Farola' },
    { id: '3', name: 'Barras Protección Tanque' },
    { id: '4', name: 'Barras Protección Motor' },
    { id: '5', name: 'Exploradora Halógena' },
    { id: '6', name: 'Exploradora HID' },
    { id: '7', name: 'Luces Farola HID' },
    { id: '8', name: 'Manilares Térmicos' },
    { id: '9', name: 'Navegador GPS Autosura' },
    { id: '10', name: 'Protector Carter' },
    { id: '11', name: 'Protector Radiadorrefrigerante' },
    { id: '12', name: 'Protector Radiador Aceite' },
    { id: '13', name: 'Sliders' },
    { id: '14', name: 'Soporte Maletas Blandas' },
    { id: '15', name: 'Parrilla Trasera' },
    { id: '16', name: 'Soporte Maleta Rígida' },
    { id: '17', name: 'Hand-Saver' },
    { id: '18', name: 'Protector Tapa De Válvulas' },
  ]);

  // Accesorios seleccionados por el usuario
  selectedAccessories = signal<SelectedAccessory[]>([
    {
      id: crypto.randomUUID(),
      accessoryId: null,
      accessoryName: '',
      searchTerm: '',
      showDropdown: false,
    },
  ]);

  // Computed: Verificar si hay al menos un accesorio seleccionado
  hasSelectedAccessory = computed(() => {
    return this.selectedAccessories().some((item) => item.accessoryId !== null);
  });

  // Computed: Verificar si el último accesorio tiene selección
  canAddMoreAccessories = computed(() => {
    const accessories = this.selectedAccessories();
    if (accessories.length === 0) return false;

    // El último accesorio debe tener una selección válida
    const lastAccessory = accessories[accessories.length - 1];
    return lastAccessory.accessoryId !== null && this.availableAccessories().length > 0;
  });

  // Computed: Validar si el formulario es válido
  isFormValid = computed(() => {
    const rawValue = this.totalValue().replace(/[^0-9]/g, '');
    const numericValue = Number(rawValue);
    const isValid =
      this.hasSelectedAccessory() &&
      numericValue > 0 &&
      !this.isGreaterThanTenPercent();

    console.log('Computando si es un formulario válido:', isValid);
    return isValid;
  });

  // Accesorios disponibles (no seleccionados)
  availableAccessories = computed(() => {
    const selectedIds = this.selectedAccessories()
      .map((s) => s.accessoryId)
      .filter((id) => id !== null);

    return this.allAccessories().filter((acc) => !selectedIds.includes(acc.id));
  });

  allowVariablesToUploadFiles = ['0KMAccesorios', 'full'];
  disableSubmitButton = signal<boolean>(false);
  vehicleValue = signal<number | null>(0);
  showTenPercentError = signal<boolean>(false);
  isGreaterThanTenPercent = signal<boolean>(false);
  exceptionsService = inject(ExceptionService);
  sessionId = '';
  UpdatedLeadData = getFromStorage<any>('UpdatedLeadData', 'session') || {};
  codigoAsesor: string | undefined;

  ngOnInit(): void {
    this.OnerousValue = getFromStorage<string>('OnerousSelection', 'session') || '';

    if (this.allowVariablesToUploadFiles.includes(this.OnerousValue)) {
      this.disableUpdatedFile.set(false);
    }

    const leadResponse = getFromStorage<any>('LeadResponse', 'session');
    const updatedLeadData = getFromStorage<any>('UpdatedLeadData', 'session');
    const storedVehicleValue = getFromStorage<any>('vehicleValue', 'session');
    const rawVehicleValue =
      leadResponse?.Vehiculo?.ValorAseguradoRunt ??
      leadResponse?.data?.Vehiculo?.ValorAseguradoRunt ??
      updatedLeadData?.Vehiculo?.ValorAseguradoRunt ??
      this.UpdatedLeadData?.Vehiculo?.ValorAseguradoRunt ??
      storedVehicleValue;
    if (rawVehicleValue !== undefined && rawVehicleValue !== null) {
      this.vehicleValue.set(Number(rawVehicleValue));
    }

    console.log('Valor final asignado a vehicleValue:', this.vehicleValue());

    this.sessionId = getSessionId().toString();
  }

  // Obtener accesorios disponibles para un input específico con filtro de búsqueda
  getAvailableAccessories(selectedId: string, searchTerm: string): Accessory[] {
    const currentAccessory = this.selectedAccessories().find((s) => s.id === selectedId);

    const otherSelectedIds = this.selectedAccessories()
      .filter((s) => s.id !== selectedId)
      .map((s) => s.accessoryId)
      .filter((id) => id !== null);

    const available = this.allAccessories().filter((acc) => {
      // Incluir el accesorio actualmente seleccionado en este input
      if (currentAccessory?.accessoryId === acc.id) {
        return true;
      }
      // Excluir accesorios seleccionados en otros inputs
      return !otherSelectedIds.includes(acc.id);
    });

    // Filtrar por término de búsqueda
    if (searchTerm.trim()) {
      return available.filter((acc) => acc.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }

    return available;
  }

  // Manejar cambio en el input de búsqueda
  onSearchChange(index: number): void {
    if (!this.hasSelectedAccessory()) {
      this.showAccesoryError.set(true);
    } else {
      this.showAccesoryError.set(false);
    }

    this.selectedAccessories.update((list) => {
      const newList = [...list];
      newList[index] = {
        ...newList[index],
        showDropdown: true,
        // Si está borrando el texto, limpiar la selección
        accessoryId: newList[index].searchTerm ? newList[index].accessoryId : null,
        accessoryName: newList[index].searchTerm ? newList[index].searchTerm : '',
      };
      return newList;
    });
  }

  // Manejar focus en el input
  onFocus(index: number): void {
    this.selectedAccessories.update((list) => {
      const newList = [...list];
      newList[index] = { ...newList[index], showDropdown: true };
      return newList;
    });
  }

  // Manejar blur en el input (con delay para permitir el click)
  onBlur(index: number, event: Event): void {
    console.log('Event', event);

    if (!this.hasSelectedAccessory()) {
      this.showAccesoryError.set(true);
    } else {
      this.showAccesoryError.set(false);
    }

    setTimeout(() => {
      this.selectedAccessories.update((list) => {
        const newList = [...list];
        newList[index] = { ...newList[index], showDropdown: false };
        return newList;
      });
    }, 200);
  }

  // Seleccionar un accesorio del dropdown
  selectAccessory(index: number, accessory: Accessory): void {
    this.selectedAccessories.update((list) => {
      const newList = [...list];
      newList[index] = {
        ...newList[index],
        accessoryId: accessory.id,
        accessoryName: accessory.name,
        searchTerm: accessory.name,
        showDropdown: false,
      };
      return newList;
    });
  }

  // Agregar nuevo campo de accesorio
  addAccessory(): void {
    if (this.canAddMoreAccessories()) {
      this.selectedAccessories.update((list) => [
        ...list,
        {
          id: crypto.randomUUID(),
          accessoryId: null,
          accessoryName: '',
          searchTerm: '',
          showDropdown: false,
        },
      ]);
    }
  }

  // Eliminar campo de accesorio
  removeAccessory(id: string): void {
    if (this.selectedAccessories().length > 1) {
      this.selectedAccessories.update((list) => list.filter((item) => item.id !== id));
    }
  }

  // Obtener valores seleccionados para enviar al backend
  getSelectedAccessoriesData(): Accessory[] {
    return this.selectedAccessories()
      .map((selected) => {
        if (!selected.accessoryId) return null;

        const accessory = this.allAccessories().find((acc) => acc.id === selected.accessoryId);

        return accessory;
      })
      .filter((acc) => acc !== null && acc !== undefined) as Accessory[];
  }

  handleValueChange(event: Event) {
    const totalAccessoriesValue = event.toString();

    if (totalAccessoriesValue === '') {
      this.showError.set(true);
      this.totalValue.set('');
    }

    const newVehicleValue = this.vehicleValue();
    const tenPercent = newVehicleValue ? newVehicleValue * 0.1 : 0;

    if (tenPercent < Number(totalAccessoriesValue.replace(/[^0-9.-]+/g, ''))) {
      if (this.OnerousValue !== '0KMAccesorios') {
        // this.showError.set(true);
        this.showTenPercentError.set(true);
        this.errorMessage.set(
          `El valor total de los accesorios no puede ser mayor al 10% del valor del vehículo (${new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(tenPercent)})`,
        );
        this.isGreaterThanTenPercent.set(true);
        // this.totalValue.set('');
        return;
      }
    } else {
      this.showTenPercentError.set(false);
      this.isGreaterThanTenPercent.set(false);
    }

    this.totalValue.set(totalAccessoriesValue);
    const vehiclePlusAccesoriesValue =
      Number(this.vehicleValue()!) + Number(totalAccessoriesValue.replace(/[^0-9.-]+/g, ''));
    this.ceroKmPlusAccesoriesValue.set(vehiclePlusAccesoriesValue);
  }

  handleRoute(onerousValue: string, info?: unknown) {
    if (onerousValue === 'Accesorios') {
      saveToStorage('vehiclePlusAccesoriesValue', this.ceroKmPlusAccesoriesValue(), 'session');
      this.router.navigate([LOADER_MOTO], { skipLocationChange: true });
      return;
    }

    if (onerousValue === '0KMAccesorios') {
      saveToStorage('AccesoriesInfo', info, 'session');
      saveToStorage('accesoriesValue', this.totalValue(), 'session');
      this.router.navigate([`/${ONEROSO}/${CEROKM}`], { skipLocationChange: true });
      return;
    }

    if (onerousValue === 'PrendaAccesorios') {
      saveToStorage('AccesoriesInfo', info, 'session');
      this.router.navigate([LOADER_MOTO], { skipLocationChange: true });
      return;
    }

    if (onerousValue === 'full') {
      saveToStorage('AccesoriesInfo', info, 'session');
      this.router.navigate([`/${ONEROSO}/${CEROKM}`]);
      return;
    }

    this.router.navigate([LOADER_MOTO]);
  }

  // Manejar envío del formulario
  onSubmit(): void {
    const data = getFromStorage<any>('LeadResponse', 'session');
    this.dataLayerService.pushDataLayerOnerous(
      'Button',
      'moto_ecommerce_step_2.4_Accesorios',
      'Accesorios',
    );
    if (!this.hasSelectedAccessory()) {
      this.showError.set(true);
      this.showAccesoryError.set(true);
      // this.errorMessage.set('Debes seleccionar al menos un accesorio para continuar');
      return;
    }

    if (this.totalValue().trim() === '') {
      this.showError.set(true);
      this.errorMessage.set('El valor total es obligatorio');
      return;
    }

    if (this.isFormValid()) {
      const reqAccessories = this.buildAccessoriesRequest();

      if (this.filesToSend().length > 0) {
        this.handleFilesSequentially(this.filesToSend());
      }

      if (this.isGreaterThanTenPercent()) {
        this.handleExceptionsForAccessoriesLead();
        return;
      }

      this.leadService
        .UpdateInfoLead(reqAccessories, data?.data?.Id)
        .pipe(
          catchError((error) => {
            console.error('Error no bloqueante al actualizar lead de accesorios:', error);
            return of({ success: false, data: null });
          })
        )
        .subscribe((response) => {
          console.log('Respuesta actualización de accesorios:', response);
          if (response?.data) {
            saveToStorage('LeadResponse', response.data, 'session');
          }
          this.handleRoute(this.OnerousValue, reqAccessories);
        });
    }

    this.showError.set(false);
  }

  private handleExceptionsForAccessoriesLead() {
    const ExceptionData = {
      required_status: '',
      percentege_lead: 0,
    };

    const urlParams = new URLSearchParams(window.location.search);
    this.codigoAsesor = urlParams.get('codigoAsesor') || '';

    ExceptionData.percentege_lead = 45;
    ExceptionData.required_status = 'Accesorios supera valor';

    this.exceptionsService
      .addExceptionNew(
        this.sessionId,
        this.UpdatedLeadData.lead_id || '',
        ExceptionData.required_status,
        ExceptionData.percentege_lead,
        'Habilitado',
      )
      .pipe(
        catchError((error) => {
          console.error('Error no bloqueante registrando excepción:', error);
          return of({ data: { Success: false } });
        })
      )
      .subscribe(() => {
        this.codigoAsesor
          ? this.router.navigate([COTIZACION_PAUSA], {
            queryParams: { codigoAsesor: this.codigoAsesor },
          })
          : this.router.navigate([COTIZACION_PAUSA]);
      });
  }

  private buildAccessoriesRequest() {
    // Aquí puedes procesar el formulario
    const accessories = this.getSelectedAccessoriesData().map((acc) => {
      return { nombre: acc.name };
    });

    //const data = this.storageService.getLeadData();

    const data = getFromStorage<any>('LeadResponse', 'session');
    console.log('DATA DEL STORAGE', data);

    const totalValue = this.totalValue();

    const requestAccessories = {
      TieneAccesoriosAdicionales: true,
      accesoriosAdicionales: {
        listaAccesorios: accessories,
        Monto: totalValue,
      },
    };

    const updateAccesoriesData = {
      lead_id: data?.data?.Id || data?.lead_id || '',
      accept_tos: data?.data?.lead?.accept_tos || data?.accept_tos || true,
      set_utm_campaign: this.utmHandlerService.getUtmParams()['utm_campaign'] || '',
      set_utm_content: this.utmHandlerService.getUtmParams()['utm_content'] || '',
      set_utm_medium: this.utmHandlerService.getUtmParams()['utm_medium'] || '',
      set_utm_source: this.utmHandlerService.getUtmParams()['utm_source'] || '',
      ...requestAccessories,
    };

    return updateAccesoriesData;
  }

  handleFilesUploaded(files: UploadedFile[]) {
    console.log('Archivos subidos recibidos en NewVehicleComponent:', files);
    this.filesToSend.set(files);
  }

  private handleFilesSequentially(files: UploadedFile[]) {
    const completedFiles = files.filter((f) => f.status === 'completed');

    from(completedFiles)
      .pipe(
        concatMap((archivo) =>
          this.sendFiles(archivo).pipe(
            catchError((err) => {
              console.error('Error no bloqueante subiendo archivo individual:', err);
              return of(null); // Continúa con el siguiente archivo si este falla
            })
          )
        )
      )
      .subscribe({
        next: (response) => console.log('Archivo enviado:', response),
        error: (error) => console.error('Error en pipeline de archivos:', error),
        complete: () => console.log('Proceso de envío de archivos finalizado'),
      });
  }

  private sendFiles(file: any) {
    const leadId = String(getFromStorage('LeadId', 'session'));
    const format = file.mimeType.split('/')[1];

    const RequestAccessoriesKM: reqUploadFile = {
      recordId: leadId,
      fileType: 'FacturaAccesorios',
      fileFormat: format,
      fileBase64: file.base64,
    };

    console.log('Request Cero Km', RequestAccessoriesKM);

    return this.uploadFileService.uploadFiles(RequestAccessoriesKM);
  }

  handleDisabledButton(event: boolean): void {
    this.disableSubmitButton.set(event);
  }
}
